"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comment_notification = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var comment_notification = function comment_notification(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'comment-notification-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M17.7095 9.82201C17.7363 10.0841 17.75 10.35 17.75 10.6191C17.75 12.0131 17.3813 13.3229 16.7359 14.4542L17.7115 17.382C17.8013 17.6515 17.7312 17.9486 17.5303 18.1494C17.3295 18.3503 17.0324 18.4204 16.7629 18.3306L13.8352 17.355C12.7038 18.0004 11.394 18.3691 10 18.3691C5.71979 18.3691 2.25 14.8993 2.25 10.6191C2.25 6.33887 5.71979 2.86908 10 2.86908C10.2691 2.86908 10.535 2.8828 10.7971 2.90957C10.5104 3.35337 10.2921 3.84549 10.157 4.37102C10.1048 4.36973 10.0525 4.36908 10 4.36908C6.54822 4.36908 3.75 7.1673 3.75 10.6191C3.75 14.0709 6.54822 16.8691 10 16.8691C11.2309 16.8691 12.3766 16.514 13.3429 15.901C13.5333 15.7802 13.7679 15.7515 13.9818 15.8228L15.8144 16.4334L15.2037 14.6009C15.1324 14.387 15.1611 14.1524 15.2819 13.962C15.8949 12.9957 16.25 11.85 16.25 10.6191C16.25 10.5666 16.2494 10.5142 16.2481 10.4621C16.7736 10.327 17.2657 10.1087 17.7095 9.82201Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M19.0001 5.61908C19.0001 7.82822 17.2092 9.61908 15.0001 9.61908C12.7909 9.61908 11.0001 7.82822 11.0001 5.61908C11.0001 3.40994 12.7909 1.61908 15.0001 1.61908C17.2092 1.61908 19.0001 3.40994 19.0001 5.61908Z',
    fill: '#B91C1C'
  }));
};

exports.comment_notification = comment_notification;